<template>
  <div style="">
    <el-card
      :body-style="{
        padding: '0px',
      }"
    >
      <el-card
        style="height: calc(100vh - 70px); width: 100%"
        :body-style="{
          padding: '0px 20px',
          height: '100%',
        }"
      >
        <div
          style="
            height: 40px;
            display: flex;
            font-size: 18px;
            font-weight: bold;
            align-items: center;
          "
        >
          <div style="color: #000">
            <span
              style="cursor: pointer"
              @click="
                $router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)
              "
              >{{ backName || '工作台' }}</span
            >
            <i class="el-icon-arrow-right"></i>
          </div>
          <div style="color: #606266" class="ellipsis">设备信息审核</div>
        </div>
        <div
          style="display: flex; align-items: center; width: 100%; height: 110px"
          class="headData"
          v-loading="Summarizingloading"
        >
          <div
            style="height: 100%; width: 100%; display: flex; gap: 20px"
            :gutter="20"
          >
            <!-- <el-col :span="4" style="height: 100%">
              <el-card style="width: 100%; height: 110px">
                <el-statistic
                  :value="
                    Math.round(Number(SummarizingInfo.TwoSupplierCount || 0))
                  "
                  :value-style="{
                    fontSize: '24px',
                  }"
                >
                  <div slot="title">
                    <div
                      style="font-size: 18px; font-weight: bold; color: #e6a23c"
                    >
                      分包数量
                    </div>
                  </div>
                </el-statistic>
              </el-card>
            </el-col> -->
            <div :span="4" :style="`width:${100 / 5}%;height:100%`">
              <el-card style="width: 100%; height: 110px">
                <el-statistic
                  :value="Math.round(Number(SummarizingInfo.deviceCount || 0))"
                  :value-style="{
                    fontSize: '24px',
                  }"
                >
                  <div slot="title">
                    <div
                      style="font-size: 18px; font-weight: bold; color: #e6a23c"
                    >
                      设备数量
                    </div>
                  </div>
                </el-statistic>
              </el-card>
            </div>
            <div :span="4" :style="`width:${100 / 5}%;height:100%`">
              <el-card style="width: 100%; height: 110px">
                <el-statistic
                  :value="
                    Math.round(Number(SummarizingInfo.DocumentCount || 0))
                  "
                  :value-style="{
                    fontSize: '24px',
                  }"
                >
                  <div slot="title">
                    <div
                      style="font-size: 18px; font-weight: bold; color: #e6a23c"
                    >
                      文档数量
                    </div>
                  </div>
                </el-statistic>
              </el-card>
            </div>
            <div :span="4" :style="`width:${100 / 5}%;height:100%`">
              <el-card style="width: 100%; height: 110px">
                <el-statistic
                  :value="
                    Math.round(Number(SummarizingInfo.AccessoryCount || 0))
                  "
                  :value-style="{
                    fontSize: '24px',
                  }"
                >
                  <div slot="title">
                    <div
                      style="font-size: 18px; font-weight: bold; color: #e6a23c"
                    >
                      备件数量
                    </div>
                  </div>
                </el-statistic>
              </el-card>
            </div>
            <div :span="4" :style="`width:${100 / 5}%;height:100%`">
              <el-card
                style="width: 100%; height: 100%; position: relative"
                :body-style="{
                  padding: 0,
                }"
              >
                <div
                  style="width: 100%; height: calc(100%); margin-top: 60px"
                  id="DeviceProgress"
                ></div>
                <div
                  style="
                    height: 30px;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    text-align: center;
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 30px;
                  "
                >
                  提交率
                </div>
              </el-card>
            </div>
            <div :span="4" :style="`width:${100 / 5}%;height:100%`">
              <el-card
                style="width: 100%; height: 100%; position: relative"
                :body-style="{
                  padding: 0,
                }"
              >
                <div
                  style="width: 100%; height: calc(100%); margin-top: 60px"
                  id="DocumentProgress"
                ></div>
                <div
                  style="
                    height: 30px;
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    text-align: center;
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 30px;
                  "
                >
                  通过率
                </div>
              </el-card>
            </div>
          </div>
        </div>
        <div v-loading="loading" style="height: calc(100% - 130px)">
          <el-row
            style="
              height: 40px;
              display: flex;
              align-items: center;

              margin-top: 10px;
            "
          >
            <el-input
              v-model="searchValue"
              placeholder="供应商名称"
              clearable
              style="width: 220px; margin-right: 10px"
            ></el-input>
            <el-input
              v-model="DeviceName"
              placeholder="设备名称/编号"
              clearable
              style="width: 220px; margin-right: 10px"
            ></el-input>
            <el-button
              type="primary"
              @click="searchData"
              style="margin-right: 10px"
              >查询</el-button
            >
            <el-radio-group
              v-model="Status"
              @change="searchData"
              style="margin-right: 10px"
            >
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button :label="1">待审核</el-radio-button>
              <el-radio-button :label="2">已审核</el-radio-button>
              <el-radio-button :label="4">驳回</el-radio-button>
            </el-radio-group>
          </el-row>
          <div style="height: calc(100% - 40px); overflow-x: hidden">
            <el-table :data="tableData" height="calc(100% - 78px)">
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              ></el-table-column>
              <el-table-column
                label="设备编号"
                prop="device_no"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备名称"
                prop="device_name"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备规格"
                prop="specification"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="设备数量"
                prop="Num"
                align="right"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="安装日期"
                prop="purchase_date"
                align="center"
                sortable
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="填写人"
                prop="cVenName"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="生产厂家名称"
                prop="manufacturer"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                label="维修商名称"
                prop="maintenance"
                align="center"
                sortable
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- <el-table-column
                label="提交人"
                prop="SubmitUserName"
                align="center"
                sortable
              >
              </el-table-column> -->
              <el-table-column
                label="提交日期"
                prop="SubmitTime"
                width="130"
                align="center"
                sortable
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ moment(scope.row.SubmitTime).format('YYYY-MM-DD') }}
                </template>
              </el-table-column>
              <el-table-column
                prop="Status"
                label="状态"
                align="center"
                width="130"
                sortable
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.Status == 1" type="warning"
                    >{{
                      scope.row.Reviewer?.length == 1 ? '部分审核' : '待审核'
                    }}
                  </el-tag>
                  <el-tag
                    v-if="scope.row.Status == 2 || scope.row.Status == 3"
                    type="success"
                    >已审核
                  </el-tag>
                  <el-tag v-if="scope.row.Status == 4" type="danger"
                    >驳回
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="审核人"
                prop="Reviewer"
                width="130"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-for="item in scope.row.Reviewer" :key="item">{{
                    item
                  }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="active"
                label="操作"
                width="130"
                align="center"
              >
                <template slot-scope="scope">
                  <!-- <el-button @click="handleprint(scope.row)" type="text" size="mini"
                        >移交详情</el-button
                      > -->
                  <el-button
                    @click="handleClick(scope.row)"
                    type="text"
                    size="mini"
                    >详情</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="openInfo(scope.row)"
                    >记录</el-button
                  >
                  <el-button
                    @click="revocation(scope.row)"
                    type="text"
                    size="mini"
                    style="color: #e6a23c"
                    v-if="
                      (scope.row.Status == 1 &&
                        scope.row.Reviewer?.length == 1) ||
                      scope.row.Status == 2 ||
                      scope.row.Status == 3 ||
                      scope.row.Status == 4
                    "
                    >撤销</el-button
                  >
                  <!-- <el-button
                        @click="handleAutd(scope.row, 2)"
                        type="text"
                        size="mini"
                        v-if="scope.row.Status == 1"
                        >通过</el-button
                      >
                      <el-button
                        @click="handleAutd(scope.row, 3)"
                        type="text"
                        size="mini"
                        style="color: #f56c6c"
                        v-if="scope.row.Status == 1"
                        >驳回</el-button
                      > -->
                </template>
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: right;
              "
            >
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.PageIndex"
                :page-sizes="pagination.PageSizes"
                :page-size="pagination.PageRows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </el-card>
    </el-card>
    <ScheduleView
      ref="ScheduleView"
      @refresh="
        () => {
          this.getTableData()
          this.getSummarizingInfo()
        }
      "
    ></ScheduleView>
    <InfoStatistic ref="InfoStatistic"></InfoStatistic>
  </div>
</template>
<script>
import ScheduleView from './ScheduleView.vue'
import InfoStatistic from './InfoStatistic.vue'
import * as echarts from 'echarts'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      echarts,
      moment,
      Status: '',
      DeviceName: '',
      leftLoading: false,
      tableData: [],
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      searchValue: '',
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      devId: '',
      loading: false,
      SummarizingInfo: {},
      Summarizingloading: false,
      TitleData: [],
      backName: '',
      pId: '',
      InstallationArea: '',
      BuildingFloor: '',
      BuildingId: '',
      BuildingFloorList: [],
    }
  },
  props: {
    treeShow: {
      type: Boolean,
      default: false,
    },
  },
  components: { ScheduleView, InfoStatistic },
  methods: {
    revocation(row) {
      this.$confirm(`将撤销该设备本次审核, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(`/PB/PB_Project/GetProjectPanelData`, {
            Panel: 'Audit',
            DeviceId: row.Id,
            ProjectId: this.pId,
            SupplierId: row.SubmitUserId,
            Status: 5,
            UserId: this.userInfo.PropertyId,
          })
          .then((res) => {
            if (res.Success) {
              this.$notify.success(res.Msg)
              this.getTableData()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    openInfo(row) {
      this.$refs.InfoStatistic.openDrawer({
        ProjectId: this.pId,
        InforType: 1,
        SupplierId: row.SubmitUserId,
        deviceId: row.Id,
      })
    },
    getBuildingFloorList() {
      this.$http
        .post('/PB/PB_Project/GetProjectPanelData', {
          Panel: 'BuildingFloor',
          BuildingId: this.BuildingId,
        })
        .then((res) => {
          if (res.Success) {
            this.BuildingFloorList = res.Data || []
          }
        })
    },
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    handleAutd(row, num) {
      this.$confirm(
        `将${num == 2 ? '审核' : '驳回'}通过该设备, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$http
          .post(
            `/Base_ProjectWork/Base_Project/ProjectDeviceToExamine?DeviceId=${row.Id}&Status=${num}`
          )
          .then((res) => {
            if (res.Success) {
              this.$notify.success(res.Msg)
              this.getTableData()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    getSummarizingInfo() {
      this.Summarizingloading = true
      this.$http
        .post('/PB/PB_Project/GetProjectPanelData', {
          Panel: 'DeviceStatistics',
          ProjectId: this.pId,
          DeviceType: this.devId,
          BuildingFloor: this.BuildingFloor,
          BuildingId: this.BuildingId,
          InstallationArea: this.InstallationArea,
        })
        .then((res) => {
          this.Summarizingloading = false
          if (res.Success) {
            this.SummarizingInfo = res.Data
            this.$nextTick(() => {
              for (let index = 0; index < 2; index++) {
                var chartDom = document.getElementById(
                  index == 0 ? 'DeviceProgress' : 'DocumentProgress'
                )
                var myChart = echarts.init(chartDom)
                var option
                option = {
                  tooltip: {
                    formatter: '{a} : {c}%',
                  },
                  series: [
                    {
                      name: index == 0 ? '提交率' : '通过率',
                      type: 'gauge',
                      startAngle: 180,
                      endAngle: 360,
                      min: 0,
                      max: 100,
                      splitNumber: 10,
                      radius: '100%',
                      progress: {
                        show: true,
                        width: 5, //进度条宽度
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },

                        roundCap: true,
                      },
                      // 外层轴线
                      axisLine: {
                        lineStyle: {
                          width: 5,
                        },
                      },
                      axisTick: {
                        //刻度线
                        show: true,
                        distance: 1,
                        length: 2,
                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      splitLine: {
                        //表盘内刻度文字上刻度线
                        distance: 1,
                        show: true, // 显示分割线
                        length: 4, // 分割线长度，可以根据需要调整

                        lineStyle: {
                          width: 1,
                          color: '#999',
                        },
                      },
                      axisLabel: {
                        //表盘内刻度文字
                        distance: 6,
                        color: '#999',
                        fontSize: 8,
                      },
                      // center: ["50%", "50%"],
                      // radius: "90%",
                      pointer: {
                        width: 2, // 指针宽度，可以根据需要调整
                        length: '70%', // 指针长度，可以根据需要调整为百分比或具体数值
                        itemStyle: {
                          color: index == 0 ? '#409eff' : '#67C23A',
                        },
                      },
                      detail: {
                        formatter: '{value}%',
                        textStyle: {
                          fontSize: 12,
                          color: '#333',
                        },

                        offsetCenter: [0, 10], // 详细指标位置，可以根据需要调整
                      },

                      data: [
                        {
                          value:
                            index == 0
                              ? this.SummarizingInfo.DeviceProgress || 0
                              : this.SummarizingInfo.DocumentProgress || 0,
                          // name: index == 0 ? "设备提交率" : "文档通过率",
                        },
                      ],
                    },
                  ],
                }

                option && myChart.setOption(option)
              }
            })
          } else {
            this.SummarizingInfo = {}
            this.$notify.error(res.Msg)
          }
        })
    },
    searchData() {
      // if (this.devId == "") {
      //   return this.$notify.error("请选择分类后查询");
      // }
      this.pagination.PageIndex = 1
      this.getTableData()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getTableData()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getTableData()
    },

    getTableData() {
      this.loading = true

      this.$http
        .post(
          '/PB/PB_Project/GetProjectPanelData',
          {
            Panel: 'DeviceInstallationAreaList',
            ProjectId: this.pId,
            DeviceType: this.devId,
            InstallationArea: this.InstallationArea,
            BuildingFloor: this.BuildingFloor,
            BuildingId: this.BuildingId,
            Keyword: this.searchValue,
            DeviceName: this.DeviceName,
            PageIndex: this.pagination.PageIndex,
            PageRows: this.pagination.PageRows,
            State: this.Status == '' ? undefined : this.Status,
          }
          // {

          //   PageIndex: this.pagination.PageIndex,
          //   PageRows: this.pagination.PageRows,
          //   SortField: "Id",
          //   SortType: "asc",
          //   Search: [
          //     {
          //       Condition: "DeviceType",
          //       Keyword: this.devId,
          //     },
          //     {
          //       Condition: "cVenName",
          //       Keyword: this.searchValue,
          //     },
          //   ],
          // }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.tableData = res.Data.TableData
            this.TitleData = res.Data.TitleData
            this.pagination.total = res.Data.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleClick(row) {
      this.$refs.ScheduleView.openDrawer(row)
    },
    getTreeData() {
      this.leftLoading = true
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectDevice?ProjectId=' +
            this.pId
        )

        .then((res) => {
          this.leftLoading = false
          if (res.Success) {
            let Data = res.Data.Data
            this.treeData = Data
          }
        })
    },

    filterNode(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    leftDataSearch() {
      this.$refs.tree.filter(this.filterText)
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    $route: {
      handler(n, o) {
        console.log(n, 'rorrorororo')
        this.pId = n.query.id
        this.BuildingId = n.query.BuildingId
        // this.BuildingFloor = n.query.BuildingFloor;
        this.backName = window.localStorage.getItem('ProjectName') || ''
        this.devId = n.query.devId || ''
        this.InstallationArea = n.query.InstallationArea || ''
        console.log(this.devId, '22222222222222222')
        if (!this.treeShow) {
          this.getTreeData()
        }
        this.getTableData()
        this.getBuildingFloorList()
        this.getSummarizingInfo()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
  font-weight: bold;
}

::v-deep .el-tree-node {
  white-space: normal;
  .el-tree-node__content {
    height: 100%;
  }
}
::v-deep .el-descriptions-item__cell {
  width: 25%;
  text-align: right;
}
::v-deep .descriptionsLabel {
  font-weight: 800 !important;
  // color: #000;
  font-size: 14px;
}
::v-deep .el-progress-bar__innerText {
  color: #ffffff !important;
}
::v-deep .con .number {
  color: #e6a23c;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
::v-deep .headData .el-card__body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .headData .el-card__body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
